import { normalizeValue } from '@helpers';

const schema = {
  amount: {
    type: 'text',
    errorMessage: ['errors.foundsOut.required'],
    isValid: [(value) => normalizeValue(value) > 0],
  },
};

export default schema;
